/**
 * Design System Constants
 * Standardized spacing, typography, and sizing across the admin portal
 */

/**
 * Spacing Scale
 * Use these consistently for padding, margins, and gaps
 */
export const SPACING = {
  xs: '4px',    // Tight UI elements, subtle separation
  sm: '8px',    // Small gaps between elements
  md: '12px',   // Default spacing, form field gaps
  lg: '16px',   // Standard container padding
  xl: '24px',   // Section spacing, major padding
  xxl: '32px',  // Large section separation
} as const;

/**
 * Typography Scale
 * Consistent font sizes, weights, and line heights
 */
export const TYPOGRAPHY = {
  h1: {
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: '1.3',
  },
  h2: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '1.35',
  },
  h3: {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '1.4',
  },
  body: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '1.5',
  },
  bodySmall: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '1.4',
  },
  label: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '1.4',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
} as const;

/**
 * Responsive Breakpoints
 */
export const BREAKPOINTS = {
  mobile: 375,
  tablet: 640,
  desktop: 1024,
  wide: 1280,
} as const;

/**
 * Card & Component Sizing
 */
export const SIZING = {
  sidebarWidth: '240px',
  sidebarWidthMobile: '220px',
  maxContentWidth: '1400px',
  minCardWidth: '220px',
} as const;
